export const getloaderSelector = state => state.loader.show;